import { FabricCanvas } from '@/components/Editor/types/fabric';

export const disposeCanvas = (canvas: FabricCanvas): void => {
  if (canvas) {
    canvas.clear();
    canvas.dispose();
  }
};
